export default __webpack_public_path__ + "static/media/heat-6.94367fb9.png";